import React from 'react';
import styles from './ContactReconnectCadence.module.scss';
import Contact from '@models/Contact';
import { useDispatch, useSelector } from 'react-redux';
import { reconnectCadenceSelector } from '@actions/reconnect';
import { openModal, selectSelectedContact, setActiveContact } from '@actions/ui';

const ReconnectBadgeIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12">
    <defs>
      <linearGradient
        id="reconnectBadgeGrad"
        x1="20%"
        x2="80%"
        y1="0%"
        y2="100%"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="45%" stopColor="#FF7233" />
        <stop offset="100%" stopColor="#FFD34F" />
      </linearGradient>
    </defs>
    <circle cx="6" cy="6.47" r="1" fill="url(#reconnectBadgeGrad)" />
    <path
      fill="none"
      stroke="url(#reconnectBadgeGrad)"
      strokeLinecap="round"
      strokeWidth="0.86"
      d="M7.43 8.5A2.5 2.5 0 0 0 6.01 3.97a2.5 2.5 0 0 0-1.43 4.54M8.67 9.85A4.34 4.34 0 0 0 6 2.14a4.34 4.34 0 0 0-2.67 7.71"
    />
  </svg>
);

export function ContactReconnectCadenceBadge({ contact }: { contact: Contact }) {
  const dispatch = useDispatch();
  const cadence = useSelector(reconnectCadenceSelector(contact?.id));
  const selectedContact = useSelector(selectSelectedContact);

  const editCadence = () => {
    if (selectedContact?.id !== contact.id) {
      dispatch(setActiveContact(contact));
    }

    dispatch(openModal('reconnect'));
  };

  if (!cadence || cadence.type == 'none') {
    return null;
  }

  return (
    <div className={styles.badge} onClick={editCadence}>
      <ReconnectBadgeIcon />
      <span className={styles.text}>{cadence.type}</span>
    </div>
  );
}
